<template>
  <div class="container">
    <div class="items">
      <span style="cursor: pointer">通知公告</span>
      <img :src="logo" alt="" >
    </div>
    <vue-seamless-scroll :data="noticeList" :class-option="optionLeft" class="seamless-warp2">
      <ul class="item">
        <li v-for="item in noticeList" v-text="item.title" @click="toNew(item.article_id)"></li>
      </ul>
    </vue-seamless-scroll>
  </div>
</template>

<script>
import logo from '@/assets/log1.png'
import axios from "axios";
import { orgId, requestUrl } from '../common/cons'
export default {
  name: "HomeTabs-right",
  data(){
    return{
      logo:logo,
      activeName:"",
      noticeList:[],
    }

  },
  computed: {
    optionLeft () {
      return {
        direction: 2,
        limitMoveNum: 2
      }
    }
  },
  mounted() {
    this.getNoticeList()
  },
  methods:{
    async getNoticeList () {
      const { data } = await axios.get(`${requestUrl}/notice/${orgId}`)
      this.noticeList = data
    },

    toNew(id){
      if(id!=0){
        // this.$router.push(`/content/${id}`)
        const routePath = this.$router.resolve({
          path: `/content/${id}`
        })
        window.open(routePath.href)
      }
    }
  }

}
</script>

<style scoped>
.container{
  width: 100%;
  height: 45px;
  background-color: white;
  display: flex;
  justify-content:flex-start;
  align-content: center;
}
.items span{
  font-size: 20px;
  color: #088a29;
  margin-right: 10px;
}
.items img{
  width: 20px; height: 20px;
}
.items{
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 150px;
  margin-right: 15px;
}

.seamless-warp2 {
  overflow: hidden;
  height: 100%;
  width: 100%;
  flex: 1;
}
.item {
  padding: 0;
  margin: 0;
  width: 100%;
  /*height: 100%;*/
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  height: 45px;
}
.item li:hover{
  cursor: pointer;
  color: #088A29;
}
.item li {
  list-style-type: none;
  float: left;
  margin-right: 30px;
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeTabs-right.vue